import { Component, Input } from '@angular/core';
import { BaseComponent } from '../../../../core/base-component';
import { formatNumericalShorthand } from '../../../../core/util/string-utils';
import { MtnMap } from '../../../../map/mtn-map';
import { Feature } from '../../../../core/models';
import { HitTrackingService } from 'src/app/core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';

@Component({
  standalone: false,
  selector: 'mtn-store-feature-card',
  templateUrl: './store-feature-card.component.html',
  styleUrls: ['./store-feature-card.component.scss']
})
export class StoreFeatureCardComponent extends BaseComponent {

  @Input()
  feature: Feature;

  @Input()
  map: MtnMap;

  formatNumericalShorthand = formatNumericalShorthand;

  constructor(private hitTrackingService: HitTrackingService) {
    super();
  }

  removeSelection(id: string): void {
    this.map.removeSelection(id, true);
  }

  onViewDetailsClick(): void {
    const store = this.feature?.getStore();
    const location = store?.space?.location;
    const shoppingCenter = store?.space?.shoppingCenter;
    const metadata = {
      storeId: store?.uuid || this.feature?.id,
      storeName: store?.name,
      addressLine1: location?.addressLine1 || '',
      city: location?.city || '',
      state: location?.state || '',
      postalCode: location?.postalCode || '',
      shoppingCenterName: shoppingCenter?.name,
      landlord: shoppingCenter?.ownerCompany?.name
    };

    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.STORE_FEATURE_CARD,
      metadata,
      USER_TRACKING_ACTIONS.VIEW_STORE_DETAILS,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.VIEW_STORE_DETAILS]
    ).subscribe(
      () => { },
      () => { }
    );

    window.open(`/detail/store/${this.feature.id}`, '_blank');
  }
}
